import styled from 'styled-components';

type Props = {
	layer: 1 | 2;
} & React.HTMLProps<HTMLDivElement>;
export const Raised = styled.div<Props>(props => ({
	backgroundColor: props.layer === 2 ? '#FFF' : '#FBFBFB',
	boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.15)',
}));
